import { T } from '../theme';
import pkg from '../../package.json';

const linkStyle = {
  color: 'rgba(255,255,255,0.5)',
  fontSize: 11,
  fontWeight: 600,
  textDecoration: 'none',
};

export default function GlobalFooterBar() {
  return (
    <div style={{
      position: 'fixed',
      bottom: 0, left: 0, right: 0,
      height: 36,
      background: T.navy,
      zIndex: 48,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      boxSizing: 'border-box',
    }}>
      <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, fontWeight: 500 }}>
        © {new Date().getFullYear()} MySpend.info · v{pkg.version}
      </span>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
        <a href="/terms" style={linkStyle}>Terms</a>
        <a href="/privacy" style={linkStyle}>Privacy</a>
        <a href="/help/" style={linkStyle}>Help Center</a>
      </div>
    </div>
  );
}
